module.exports = __webpack_public_path__ + "media/7.8cd26e34.mp3";